// extracted by mini-css-extract-plugin
export default {"form":"AuthForm_form__kV4hH","inputs":"AuthForm_inputs__rRnBX","button__wrapper":"AuthForm_button__wrapper__wdwq5","error__text":"AuthForm_error__text__OSGfv"};